// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 05502-确认导入 POST /v1/web/payUserWallets/provider/confirmImport */
export async function enterpriseConfirmImportWalletsData(
  body: API.ConfirmImportWalletsMemberDataVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOString>(
    "/v1/web/payUserWallets/provider/confirmImport",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 05501-导入发放用户数据,返回成功和失败列表 POST /v1/web/payUserWallets/provider/import/${param0}/${param1} */
export async function importMemberWalletsData(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.importMemberWalletsDataParams,
  options?: { [key: string]: any }
) {
  const { paySet: param0, gymId: param1, ...queryParams } = params;
  return request<API.YmResultVOSwimWalletsImportResultVO>(
    `/v1/web/payUserWallets/provider/import/${param0}/${param1}`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 5402-查询导入钱包记录列表 POST /v1/web/payUserWallets/provider/pageList */
export async function getSwimWalletsProviderImportRecordPageList(
  body: API.SwimWalletsProviderImportRecordPageQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimWalletsProviderImportRecordBasicVo>(
    "/v1/web/payUserWallets/provider/pageList",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 5402-查询导入钱包记录明细列表 POST /v1/web/payUserWallets/providerItem/pageList */
export async function getSwimWalletsProviderImportRecordItemPageList(
  body: API.SwimWalletsProviderImportRecordItemPageQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimWalletsProviderImportRecordItemBasicVo>(
    "/v1/web/payUserWallets/providerItem/pageList",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}
